<template>
  <div class="card bg-base-200 overflow-hidden shadow-sm">
    <div class="flex flex-col items-center gap-2 p-2">
      <div
        class="bg-base-300 flex aspect-square w-full items-center justify-center overflow-hidden"
      >
        <!-- Display image thumbnail if not errored -->
        <img
          v-if="!imageError"
          :src="imageUrl"
          :alt="type"
          class="h-full w-full object-cover"
          @error="handleImageError"
        />
        <!-- Fallback to icon if image fails to load -->
        <i v-else-if="icon" :class="[icon, 'text-4xl opacity-50']"></i>
        <span v-else class="text-xs uppercase opacity-50">{{ type }}</span>
      </div>
      <div class="text-center">
        <div class="w-full max-w-37.5 truncate text-sm font-medium">
          {{ type }}
        </div>
        <div class="text-xs opacity-60">
          {{ dayjs(created_at).format("DD/MM/YYYY HH:mm:ss") }}
        </div>
      </div>
      <button
        class="btn btn-ghost btn-xs btn-primary mt-1"
        @click.stop="download"
      >
        <i class="fa-solid fa-download mr-1"></i> Tải xuống
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import { computed, ref } from "vue";

const props = defineProps<{
  type: string;
  created_at: number;
  path: string;
}>();

const imageUrl = computed(() => {
  return `/api/v1/view/chat/${props.path}`;
});

const icon = computed(() => {
  const t = props.type.toLowerCase();
  if (t.includes("telegram")) return "fa-brands fa-telegram text-primary";
  if (t.includes("zalo")) return "fa-solid fa-message text-primary";
  if (t.includes("whatsapp") || t.includes("what"))
    return "fa-brands fa-whatsapp text-primary";
  if (t.includes("viber")) return "fa-brands fa-viber text-primary";
  if (t.includes("teams")) return "fa-brands fa-microsoft-teams text-primary";
  if (t.includes("skype")) return "fa-brands fa-skype text-primary";
  if (t.includes("messenger") || t.includes("facebook"))
    return "fa-brands fa-facebook-messenger text-primary";
  return "fa-solid fa-comments";
});

const imageError = ref(false);

const handleImageError = () => {
  imageError.value = true;
};

const download = () => {
  const url = `/api/v1/view/chat/${props.path}`;
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", props.path.split("/").pop() || "chat_history");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
</script>
